
// H5 家长端token
export const TOKEN_KEY = 'token-parent'
// H5 家长端用户信息
export const USER_KEY = 'may_parent_user'
export const WX_AUTH_STATE = 'wx_auth_state'